import React, { memo } from 'react'
import { any, string, bool } from 'prop-types'
import { styled } from '@material-ui/core'
import clsx from 'clsx'

const Sup = styled('sup')({
  fontSize: '50%',
  verticalAlign: 'super',
  '&.with-space': {
    '&--left': {
      marginLeft: '0.125em',
    },
    '&--right': {
      marginRight: '0.125em',
    },
  },
  '&:empty': {
    display: 'none',
  },
})

const Span = styled('span')(({ theme }) => ({
  position: 'relative',
  '&.disabled-sup': {
    '& sup': {
      fontSize: 'inherit',
      verticalAlign: 'inherit',
    },
  },
  '&.negative': {
    '& > *': {
      color: `${theme.palette.error.main}!important`,
    },
  },
}))

const PriceSpan = styled('span')({
  marginRight: '0 !important',
  '&.strike-through': {
    textDecoration: 'underline',
    textUnderlineOffset: '-0.35em',
    textDecorationSkipInk: 'none',
  },
})

// Helpers
const getPriceStrings = _price => {
  try {
    let price
    if (typeof _price === 'string') {
      price = Number((_price[0] === '$' ? _price.slice(1) : _price).replace(',', '')).toFixed(2)
    } else {
      price = Number(_price).toFixed(2)
    }
    const result = price.split('.')
    if (result[1] === '00' || result[1] === '0') {
      return [result[0]]
    }
    return result
  } catch {
    return ['Invalid Price']
  }
}

// Component
const PriceAtom = ({ className, price, disableSuperscript, strikeThrough, negative = false, dataTestId }) => {
  const [dollars, cents] = getPriceStrings(price)

  return (
    <Span
      className={clsx(className, disableSuperscript && 'disabled-sup', negative && 'negative')}
      data-testId={dataTestId}
    >
      <PriceSpan className={clsx(strikeThrough && 'strike-through')} aria-hidden="true">
        {negative && <span>-</span>}
        <Sup>$</Sup>
        {dollars}
      </PriceSpan>
      <Sup className={clsx(!strikeThrough && 'with-space--left')} aria-hidden="true">
        {cents && disableSuperscript && <span>.</span>}
        {cents}
      </Sup>
      <span className="hide508">{`$${dollars}${cents ? `.${cents}` : ``}`}</span>
    </Span>
  )
}

PriceAtom.propTypes = {
  className: string,
  price: any,
  disableSuperscript: any,
  strikeThrough: any,
  negative: bool,
  dataTestId: string,
}

export default memo(PriceAtom)
